import { BrandProvider } from '@grupoboticario/barril-del-chavo'
import { Box, FloraTypography } from '@grupoboticario/flora-react'
import { useState } from 'react'
import { HomeCategoryItem } from 'src/@interfaces'
import { CategoryImage, CategoryLink } from './CategoryCard.styles'
import { defaultCategoriesImageByBrand } from './CategoryList.constants'

export type CategoryCardProps = { onClick?: () => void } & HomeCategoryItem

const DEFAULT_CATEGORY_IMAGE = defaultCategoriesImageByBrand[BrandProvider.getBrand()]
export const CategoryCard = ({ title, url, image, onClick }: CategoryCardProps) => {
  const [hasImageError, setHasImageError] = useState(false)

  const handleImageError = (): void => {
    setHasImageError(true)
  }

  return (
    <Box
      role="listitem"
      aria-label={title}
    >
      <CategoryLink
        to={url}
        role="link"
        reloadDocument
        data-flora="button"
        autotagging-flora="on"
        data-testid={`category-card-${title}`}
        onClick={onClick}
      >
        {hasImageError ? (
          <CategoryImage
            src={DEFAULT_CATEGORY_IMAGE}
            alt={title}
            data-testid="category-card-default-image"
          />
        ) : (
          <CategoryImage
            src={image}
            alt={title}
            onError={handleImageError}
          />
        )}
        <FloraTypography fontSize="bodySmallStandard">{title}</FloraTypography>
      </CategoryLink>
    </Box>
  )
}
